import React from 'react';
import styles from './contactUs.scss';
import Page1 from './Page1';

function ContactUs(props) {
  const {
    curPanel,
  } = props;

  return (
    <div className={`${styles['contactUs']} ${curPanel === 'contactUs' ? styles.show : styles.hide}`}>
      <Page1 />
    </div>
  );
}

export default ContactUs;